import moment from 'moment';
import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faShieldAlt } from '@fortawesome/free-solid-svg-icons';
import {
  CompletedCard,
  CompletedCardHeader,
  CompletedCardIcon,
  CompletedCardTitle,
  CompletedFieldGrid,
  CompletedField,
} from '../../../screens/CompletedQuotes/CompletedV2.styles';

function CompletedScreenInfoMonopattini({ rc_quotation, risk_quotations }) {
  return (
    <>
      <div className="col-12 col-md-6 mb-3">
        <CompletedCard className="polizze-emessa-status-step-three">
          <CompletedCardHeader>
            <CompletedCardIcon>
              <FontAwesomeIcon icon={faShieldAlt} />
            </CompletedCardIcon>
            <CompletedCardTitle>
              {rc_quotation.risk_information.product_name}
            </CompletedCardTitle>
          </CompletedCardHeader>

          <CompletedFieldGrid>
            <CompletedField>
              <dt>Compagnia</dt>
              <dd>{rc_quotation.company.name}</dd>
            </CompletedField>

            <CompletedField>
              <dt>Stato</dt>
              <dd>
                {rc_quotation.status === 7 && 'Polizza Emmesa'}
              </dd>
            </CompletedField>

            <CompletedField>
              <dt>Data Decorrenza</dt>
              <dd>
                {moment(rc_quotation.insurance_request.policy_effective_date)
                  .toDate()
                  .toLocaleDateString('it-IT')}
              </dd>
            </CompletedField>

            <CompletedField>
              <dt>Frequenza Pagamento</dt>
              <dd>
                {rc_quotation.payment_frequency === 1 ? 'Annuo' : 'Semestrale'}
              </dd>
            </CompletedField>

            <CompletedField>
              <dt>Pagato</dt>
              <dd>
                {rc_quotation.amount_paid === null
                  ? '0.00'
                  : parseFloat(rc_quotation.amount_paid).toFixed(2)}
                {' '}
                &euro;
              </dd>
            </CompletedField>

            {/* Da Pagare (temporarily hidden)
            <CompletedField>
              <dt>Da Pagare</dt>
              <dd>
                {rc_quotation.amount_paid === rc_quotation.amount
                  ? '0.00'
                  : (
                    Math.ceil(rc_quotation.amount * 100) / 100
                    - rc_quotation.amount_paid
                  ).toFixed(2)}
                {' '}
                &euro;
              </dd>
            </CompletedField>
            */}

            <CompletedField>
              <dt>Prossimo Pagamento</dt>
              <dd>
                {moment(rc_quotation.insurance_request.policy_effective_date)
                  .add(Math.floor(365 / rc_quotation.payment_frequency), 'days')
                  .toDate()
                  .toLocaleDateString('it-IT')}
              </dd>
            </CompletedField>

            <CompletedField>
              <dt>Premio</dt>
              <dd>
                {(
                  parseFloat(rc_quotation.amount)
                  - parseFloat(rc_quotation.issuance_fee)
                  - (rc_quotation.is_facile_quote === 1 ? 20.9 : 0)
                ).toFixed(2)}
                {' '}
                &euro;
              </dd>
            </CompletedField>

            <CompletedField>
              <dt>Spese di Emissione</dt>
              <dd>
                {(
                  parseFloat(rc_quotation.issuance_fee)
                  + (rc_quotation.is_facile_quote === 1 ? 20.9 : 0)
                ).toFixed(2)}
                {' '}
                &euro;
              </dd>
            </CompletedField>

            <CompletedField>
              <dt>Provvigioni</dt>
              <dd>
                {parseFloat(rc_quotation.commision).toFixed(2)}
                {' '}
                &euro;
              </dd>
            </CompletedField>

            <CompletedField>
              <dt>Brokeraggio</dt>
              <dd>
                {rc_quotation.brokerage_amount.toFixed(2)}
                {' '}
                &euro;
              </dd>
            </CompletedField>

            {/* Totale (temporarily hidden)
<CompletedField className="full total">
              <dt>Totale</dt>
              <dd>
                {(rc_quotation.amount + rc_quotation.brokerage_amount).toFixed(2)}
                {' '}
                &euro;
              </dd>
            </CompletedField>
*/}
          </CompletedFieldGrid>
        </CompletedCard>
      </div>

      {risk_quotations.map((quote, index) => (
        <div className="col-12 col-md-6 mb-3" key={index}>
          <CompletedCard className="polizze-emessa-status-step-three">
            <CompletedCardHeader>
              <CompletedCardIcon>
                <FontAwesomeIcon icon={faShieldAlt} />
              </CompletedCardIcon>
              <CompletedCardTitle>
                {quote.risk_information.product_name}
              </CompletedCardTitle>
            </CompletedCardHeader>

            <CompletedFieldGrid>
              <CompletedField>
                <dt>Compagnia</dt>
                <dd>{quote.company.name}</dd>
              </CompletedField>

              <CompletedField>
                <dt>Stato</dt>
                <dd>
                  {quote.status === 7 && 'Polizza Emmesa'}
                </dd>
              </CompletedField>

              <CompletedField>
                <dt>Data Decorrenza</dt>
                <dd>
                  {moment(quote.insurance_request.policy_effective_date)
                    .toDate()
                    .toLocaleDateString('it-IT')}
                </dd>
              </CompletedField>

              <CompletedField>
                <dt>Frequenza Pagamento</dt>
                <dd>
                  {quote.payment_frequency === 1 ? 'Annuo' : 'Semestrale'}
                </dd>
              </CompletedField>

              <CompletedField>
                <dt>Pagato</dt>
                <dd>
                  {quote.amount_paid === null
                    ? '0.00'
                    : parseFloat(quote.amount_paid).toFixed(2)}
                  {' '}
                  &euro;
                </dd>
              </CompletedField>

              {/* Da Pagare (temporarily hidden)
              <CompletedField>
                <dt>Da Pagare</dt>
                <dd>
                  {quote.amount_paid === quote.amount
                    ? '0.00'
                    : (
                      Math.ceil(quote.amount * 100) / 100
                      - quote.amount_paid
                    ).toFixed(2)}
                  {' '}
                  &euro;
                </dd>
              </CompletedField>
              */}

              <CompletedField>
                <dt>Prossimo Pagamento</dt>
                <dd>
                  {moment(quote.insurance_request.policy_effective_date)
                    .add(Math.floor(365 / quote.payment_frequency), 'days')
                    .toDate()
                    .toLocaleDateString('it-IT')}
                </dd>
              </CompletedField>

              <CompletedField>
                <dt>Premio</dt>
                <dd>
                  {parseFloat(quote.amount).toFixed(2)}
                  {' '}
                  &euro;
                </dd>
              </CompletedField>

              {/* Totale (temporarily hidden)
<CompletedField className="full total">
                <dt>Totale</dt>
                <dd>
                  {quote.amount.toFixed(2)}
                  {' '}
                  &euro;
                </dd>
              </CompletedField>
*/}
            </CompletedFieldGrid>
          </CompletedCard>
        </div>
      ))}

    </>
  );
}

export default CompletedScreenInfoMonopattini;
